import { useEffect, useState } from 'react';
import {
  Box,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import CustomModal from 'src/components/modal/customModal';
import { styled, useTheme } from '@mui/material/styles';
import FormProvider, { RHFCheckbox, RHFMultiCheckbox, RHFRadioGroup, RHFSelect, RHFTextField } from 'src/components/hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { axiosGetCall,  axiosPostCall } from 'src/services/apisCall';
import { VOICE } from 'src/lib/Enums';
import { checkButtonAccess } from 'src/utils/common';
import { jwtDecode } from 'jwt-decode';
import { GatewayList } from 'src/sections/sms/gateway/gatewayList';

const InputContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '20px',
}));
const FieldHeading = styled(Typography)(() => ({
  fontWeight: 500,
}));

const AddVoiceGateway = ({ openModal, handleCloseModal, title, forceLoad, updateUserId}) => {
  const [canSubmit, setCanSubmit] = useState(true);
  const [gatewayDetails, setGatewayDetails] = useState({});
  const [hostIpOptions, setHostIpOptions] = useState([]);

  const { email } = jwtDecode(localStorage.getItem('token'));

  const { ROUTE, CLI_TYPE, GATEWAY_STATUS } = VOICE;
  const theme = useTheme();

  const Schema = Yup.object().shape({
    hostIp: Yup.string().required('Host IP is required!'),
    name: Yup.string().required('Name is required!'),
    channels: Yup.string().required('Channels is required!'),
    gatewayCliType: Yup.string().required('Gateway Cli Type is required!'),
    cliPrefix: Yup.string().required('Cli Prefix is required!'),
    status: Yup.string().required('Gateway Status is required!'),
    gatewayPulse: Yup.string().required('Gateway Pulse is required!'),
    // country: Yup.array().of(Yup.string()).required('Country is required!'),
    dedicated: Yup.string().required('Dedicated is required!'),
    reserved: Yup.string().required('Reserved is required!'),
  });

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues: {
      hostIp: '',
      name: '',
      channels: '',
      gatewayCliType: '',
      cliPrefix: '',
      status: '',
      gatewayPulse: '',
      dedicated: '',
      reserved: '',
      country: [],
    },
  });

  const { control, watch, setValue, handleSubmit, reset, formState: { errors } } = methods;

  // Count total validation errors
  const totalErrors = Object.keys(errors).length;
  console.log(totalErrors, errors);

   const selectedCheckboxes = watch('country') || [];


  const handleIndividualChange = (value) => {
    const newSelectedValues = selectedCheckboxes.includes(value)
      ? selectedCheckboxes.filter((item) => item !== value) // Remove value if already selected
      : [...selectedCheckboxes, value]; // Add value if not selected

    setValue('country', newSelectedValues);
  };


    const COUNTRY_LIST= [
    { value: 'IN', label: "India" },
    { value: 'BD', label: "Bangladesh" },
  ];

  const onSubmit = async(data) => {
    setCanSubmit(false);
  try{
    const payload = {
      name: data.name,
      channels: data.channels,
      cliType: data.gatewayCliType,
      cliPrefix: data.cliPrefix,
      gatewayPulse: data.gatewayPulse,
      hostIp: data.hostIp,
      status: data.status,
      country: data.country,
      dedicated: data.dedicated,
      reserved: data.reserved,
    };

    if (updateUserId) {
      payload.gatewayId = updateUserId,
      payload.adminEmail = email;
      await axiosPostCall('updateVoiceGateway', payload);
    } else{
      await axiosPostCall('addVoiceGateway', payload);
    }


    renderSuccessMessage(updateUserId ? 'Gateway updated successfully' : 'Gateway added successfully');
    handleCloseModal();
    reset();
    forceLoad(true);

  } catch (error) {
    // logger.error('Add Gateway [handleSubmit]', error);
    const errorMessage = error?.message;
    renderErrorMessage(errorMessage);
  } finally {
    setCanSubmit(true);
  }
  };

  const onCancel = () => {
    reset ();
  };

useEffect(() => {
  if (updateUserId) {
    const fetchGatewayList = async () => {
      try {
        const { gatewayList } = await axiosGetCall("getVoiceGatewayList", { search: updateUserId });
        setGatewayDetails(gatewayList[0]);
      } catch (error) {
        // logger.error("Gateway List", error);
        renderErrorMessage(error?.message);
      }
    };

    fetchGatewayList();
  } else {
     setGatewayDetails({});
  }
}, [updateUserId]);



useEffect(() => {
  if (gatewayDetails) {
    const hostIpOption = hostIpOptions.find(option => option.hostID === gatewayDetails.host_id);
    setValue('hostIp', hostIpOption?.value);
    setValue('name', gatewayDetails?.name);
    setValue('channels', gatewayDetails?.channels);
    setValue('gatewayCliType', gatewayDetails?.cli_type);
    setValue('cliPrefix', gatewayDetails?.cli_prefix);
    setValue('status', gatewayDetails?.status);
    setValue('gatewayPulse', gatewayDetails?.gateway_pulse);
    setValue('country', gatewayDetails?.allowed_countries);
    setValue('dedicated', gatewayDetails?.is_dedicated);
    setValue('reserved', gatewayDetails?.is_reserved);
  }
}, [gatewayDetails]);


useEffect(() => {
  const getHostIP = async () => {
    try {
      const response = await axiosGetCall('getHostIp');
      const ipList = response.HostIpList;
      const transformedData = ipList.map((host) => ({
        label: `${host.rabbit_mq_host} HostID: ${host.host_id}`,
        hostID: host.host_id,
        value: host.rabbit_mq_host,
      }));
      setHostIpOptions(transformedData);
      console.log("Host IP Data:", transformedData);
    } catch (error) {
      console.error('Error fetching host IP:', error);
    }
  };

  getHostIP();
}, []);




  const description = (
    <Box>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack
          direction="column"
          gap={2}
          sx={{ p: '25px', overflowY: 'auto', maxHeight: '600px', height: '100%', width: '800px' }}
        >
            <InputContainer>
            <RHFSelect name="hostIp" label="Host IP" control={control}>
              {hostIpOptions.map((ele) => (
                <MenuItem key={ele.value} value={ele.value}>
                  {ele.label}
                </MenuItem>
              ))}
            </RHFSelect>
            </InputContainer>
            <InputContainer>
            <RHFTextField name="name" label="Name" placeholder="Enter Name." />
            </InputContainer>
            <InputContainer>
            <RHFTextField name="channels" label="Channels" placeholder="Enter Channels." />
            </InputContainer>
            <InputContainer>
            <RHFSelect name="gatewayCliType" label="Gateway CLI Type" control={control}>
              {CLI_TYPE.map((ele) => (
                <MenuItem key={ele.value} value={ele.value}>
                  {ele.label}
                </MenuItem>
              ))}
            </RHFSelect>
            </InputContainer>
                        <InputContainer>
            <RHFSelect name="status" label="Gateway Status" control={control}>
              {GATEWAY_STATUS.map((ele) => (
                <MenuItem key={ele.value} value={ele.value}>
                  {ele.label}
                </MenuItem>
              ))}
            </RHFSelect>
            </InputContainer>
            <InputContainer>
            <RHFTextField name="cliPrefix" label="CLI Prefix" placeholder="Enter CLI Prefix." />
            </InputContainer>
            <InputContainer>
            <RHFTextField  name="gatewayPulse" label="Gateway Pulse" placeholder="Enter Gateway Pulse." />
            </InputContainer>
            <InputContainer>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <Typography>Country</Typography>
                <RHFMultiCheckbox
                name="country"
                options={COUNTRY_LIST}
                variant="outlined"
                value={selectedCheckboxes}
                onChange={handleIndividualChange}
                />
            </Box>
            </InputContainer>
            <InputContainer>
            <Typography sx={{ mr : 5 }}>Dedicated</Typography>
            <RHFRadioGroup
                name="dedicated"
                row
                spacing={2}
                container={{ display: 'flex', alignItems: 'center' }}
                options={[
                { value: "Y", label: 'Yes' },
                { value: "N", label: 'No' },
                ]}
            />
            </InputContainer>
            <InputContainer>
            <Typography sx={{ mr : 5 }}>Reserved</Typography>
            <RHFRadioGroup
                name="reserved"
                row
                spacing={2}
                container={{ display: 'flex', alignItems: 'center' }}
                options={[
                { value: "Y", label: 'Yes' },
                { value: "N", label: 'No' },
                ]}
            />
            </InputContainer>
            
        

            {/* {checkButtonAccess("addsmsgateway", "w") && (        */}

          <Box sx={{ display: 'flex', gap: '1rem', mt: 3 }}>
            <Box
              sx={{
                width: '7.625rem',
                backgroundColor: canSubmit ? '#212B36' : 'grey',
                borderRadius: '8px',
                p: '0.562rem',
                height: '2.375rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                pointerEvents: canSubmit ? 'auto' : 'none',
              }}
              onClick={handleSubmit(onSubmit)}
            >
              <Typography sx={{ fontWeight: 600, color: '#fff' }}>
                {updateUserId ? "Update" : "Submit"}
                </Typography>
            </Box>
            <Box
              sx={{
                width: '7.625rem',
                backgroundColor: '#fff',
                borderRadius: '8px',
                p: '0.562rem',
                height: '2.375rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
              onClick={onCancel}
            >
              <Typography sx={{ fontWeight: 600, color: '#212B36' }}>Cancel</Typography>
            </Box>
          </Box>
            {/* )} */}

        </Stack>
      </FormProvider>
    </Box>
  );

  return (
    openModal && (
      <CustomModal
        open={openModal}
        title={updateUserId ? "Update Voice Gateway" : "Add New Voice Gateway"}
        description={description}
        close={handleCloseModal}
        isCloseIcon={true}
      />
    )
  );
};

export default AddVoiceGateway;
